var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "12", height: "12", viewBox: "0 0 12 12", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "g",
      { clipPath: "url(#svg3463376842a)" },
      React.createElement("path", { d: "M11.88 1.51L.188 5.735a.282.282 0 0 0-.064.498l1.748 1.194 7.934-4.184-6.716 5.015v2.031c0 .138.155.222.271.146l1.48-.982 1.457.994a.284.284 0 0 0 .401-.086l5.289-8.72c.044-.072-.027-.16-.106-.131z" })
    ),
    React.createElement(
      "defs",
      null,
      React.createElement(
        "clipPath",
        { id: "svg3463376842a" },
        React.createElement("path", { fill: "#fff", d: "M0 0h12v12H0z" })
      )
    )
  );
});